define('signin',['loader', 'jquery', 'angular', 'angular-ui-bootstrap', 'angular-resource', 'angular-sanitize', 'vspot', 'localize', 'vspot-resources', 'vspot-services', 'error-handler', 'vspot-validation'], function (loader, $, ng) {
    'use strict';

    //--------------------------------------------------------------[ Register Controller
    var signin = ng.module('signin', ['ui.bootstrap', 'localization', 'vspot.services', 'error-handler', 'vspot.validation']);

    var signinController, registerController, forgotPwController;

    signin.controller('RegisterCtrl', ['$scope', '$http', '$location', '$uibModal', function ($scope, $http, $location, $uibModal) {
        // workflow: register -> show intro video
        // alt: register -> go to login instead
        $scope.fromNav = true; // used to determine whether form is displayed in a modal or not
        $scope.open = function () {
            // let the modal controller know if we're using a modal or not
            var modalInstance = $uibModal.open({
                templateUrl: '/script/vspot-angular/templates/signin/register.html',
                controller: 'RegisterModalCtrl',
                scope: $scope
            });

            // should we open another modal when this one closes?
            modalInstance.result.then(function (result) {
                var modalInstance;

                if (result && result.action === 'signin') {
                    // clicked on the sign in button from the register modal
                    modalInstance = $uibModal.open({
                        templateUrl: '/script/vspot-angular/templates/signin/login.html',
                        controller: 'SigninModalCtrl',
                        scope: $scope
                    });

                    // should we open another modal when this one closes?
                    modalInstance.result.then(function (data) {
                        if (data && data.action === 'forgotpassword') {
                            $scope.email = data.email;
                            // clicked on the forgot password link from the login modal
                            $uibModal.open({
                                templateUrl: '/script/vspot-angular/templates/signin/forgotpassword.html',
                                controller: 'ForgotPasswordModalCtrl',
                                scope: $scope
                            }).result.then(function (action) {
                                    // show success message
                                    if (action === 'success') {
                                        $uibModal.open({
                                            templateUrl: '/script/vspot-angular/templates/signin/resetpassword.html',
                                            controller: 'ResetPasswordModalCtrl',
                                            scope: $scope
                                        });
                                    }
                                });
                        }
                    });
                } else if (result && result.action === 'register') {
                    // figure out where to send them next
                    result.callback(result.email, result.mobile_redirect);
                }
            }, undefined);
        };

        $scope.handleReg = function(e) {
            // Prevent the default action
            // e.preventDefault();

            // // Look for an existing form on the page. If it's there, focus on it. If not, open the modal.
            // var regForm = $('.vspot-registration-form');
            // if( regForm.length ) {
            //     // We found the form
            //     $('html,body').animate({scrollTop: regForm.offset().top - 20}, 800);
            //     regForm.find('input:first').focus();
            // } else {
            //     // No form, so open the modal
            //     $scope.open();
            // }
        };
    }]);

    // The inline controller isn't going to have $uibModalInstance, so it can't be injected, and
    // $injector cannot fetch $uibModalInstance, so controller code has been moved to accommodate
    signin.controller('RegisterModalCtrl', ['$scope', '$uibModalInstance', '$uibModal', '$http', 'services.User','services.googleUser', 'services.Tracking', '$timeout', function ($scope, $uibModalInstance, $uibModal, $http, User, googleUser, Tracking, $timeout) {
        $scope = registerController($scope, $uibModalInstance, $uibModal, $http, User, googleUser, Tracking, $timeout);
    }]);

    signin.controller('RegisterInlineCtrl', ['$scope', '$uibModal', '$http', 'services.User', 'services.googleUser', 'services.Tracking', '$timeout', '$rootScope', function ($scope, $uibModal, $http, User, googleUser, Tracking, $timeout, $rootScope) {
        $scope = registerController($scope, undefined, $uibModal, $http, User, googleUser, Tracking, $timeout, $rootScope);
    }]);

    registerController = function ($scope, $uibModalInstance, $uibModal, $http, User, googleUser, Tracking, $timeout, $rootScope) {
        $scope.form = {};
        $scope.submitted = false;
        $scope.emailAvailable = '';
        $scope.result = {};
        //change body min width only on home page cos google login expands the width of the page
        $('body').css('min-width', '1240px');
        /*
         *  Based on the current content experiment, decide what to do
         *  and where to go for the user.
         */
        var registerFollowup = function (email, mobileRedirect) {
            // registration was successful; introduce the user to the app
            $timeout(function() {
                if (mobileRedirect) {
                    window.location = '/mobileweb/2.0/vspot.html#register_thanks_page';
                } else {
                    window.location = '/Dashboard?welcome=true';
                }
            }, 500);
        };
        
        try {
            // track register page view for google analytics
//            _gaq.push(['_setAccount', 'UA-3705553-1'],['_trackPageview', '/organizer/register']);
            ga('send', 'pageview', '/organizer/register');
            // ga('send', 'event', category, action, label, value, nonInteraction);
            // GA4
            gtag('event', 'page_view', {
                page_path: '/organizer/register'
            });
        } catch(e) {
            // Just ignore it
        }

        // go to login screen/modal
        $scope.gotoLogin = function () {
            // are we currently in a modal?
            if ($scope.fromNav) {
                $uibModalInstance.close({
                    action: 'signin'
                }); // close modal; open login modal
            } else {
                // go to sign in page
                window.location = '/login/signin?triggerUri=' + encodeURIComponent(window.location.href) + '&fn=gotoLogin';
            }
        };

        $scope.checkEmailAvailability = function () {
            // email appears to be undefined if it is invalid
            if ($scope.form.email) {
                $scope.showLoading = true;
                User.checkEmailAvailability($scope.form.email).$promise.then(
                    function (result) {
                        $scope.showLoading = false;

                        if (result.status) {
                            $scope.result.code = '';
                            $scope.emailAvailable = true;
                        } else if (result.code) {
                            $scope.result.code = result.code;
                            $scope.result.email = $scope.form.email;
                            $scope.result.domain = result.domain;
                            $scope.emailAvailable = false;
                        } else {
                            $scope.emailAvailable = false;
                            throw new Error(result.message);
                        }
                        $scope.signinError = $scope.result;
                    }, function (err) {
                        $scope.result = err;
                        $scope.signinError = $scope.result;
                    });
            }
        };

        // sign up user
        $scope.fbRegister = function () {
            User.fbLogin(registerFollowup);
        };

        $scope.googleLogin = function() {
                googleUser.googleLogin(registerFollowup);
        };

        $scope.register = function () {
            $scope.submitted = true;
            if (!$scope.form.email || !$scope.form.password || !$scope.form.firstName || !$scope.form.lastName) {
                $scope.form.email = $('#login-email').val();
                $scope.form.password = $('#login-password').val();
                $scope.form.firstName = $('#register-fname').val();
                $scope.form.lastName = $('#register-lname').val();
            }

            if (!$scope.form.email || !$scope.form.password || !$scope.form.firstName || !$scope.form.lastName) {
                $scope.result.code = '_INVALID_LOGIN_FORM_';
                $scope.submitted = false;
            } else {
                // register the user and show any returned errors
                $scope.result = User.register($scope.form);
                $scope.result.$promise.then(function (result) {
                    // need some extra information from the user
                    // get them to complete their profile
                    if (result.status) {
                        // registration was successful

                        try {
                            // track register complete page view for google analytics
//                            _gaq.push(['_setAccount', 'UA-3705553-1'],['_trackPageview', '/organizer/registerdone']);
                            ga('send', 'pageview', '/organizer/registerdone');
                            // ga('send', 'event', category, action, label, value, nonInteraction);
                            // GA4
                            gtag('event', 'page_view', {
                                page_path: '/organizer/registerdone'
                            });
                        } catch(e) {
                            // Just ignore it
                        }

                        // ditto for google tag manager. watch for datalayer not defined (not sure if this happens but we are missing events)
                        try {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({'event': 'registerdone'});
                        } catch(err) {
                            // Just ignore it throw new Error(err);
                        }

                        // introduce the user to the app
                        if ($scope.fromNav) {
                            // in modal, close and show video modal
                            $uibModalInstance.close({
                                action: 'register',
                                email: $scope.form.email,
                                mobile_redirect: result.mobile_redirect,
                                callback: registerFollowup
                            });
                        } else {
                            // figure out where to send them next
                            registerFollowup($scope.form.email, result.mobile_redirect);
                        }
                    } else if (result.code) {
                        $scope.submitted = false;
                        $scope.result.email = result.email || $scope.form.email;
                        $scope.result.code = result.code;
                        if(result.code === '_PARAMETERS_MISSING_') {
                            //if suspected spam, redirect to org register and save form data, except password, to prefill form
                            var newFormData = {
                                firstName: $scope.form.firstName,
                                lastName: $scope.form.lastName,
                                email: $scope.form.email
                            }
                            window.localStorage.setItem('formData', JSON.stringify(newFormData));
                            $timeout(function(){
                                window.location = '/Organizer/Register/';
                            }, 1000);

                        }
                    } else {
                        $scope.submitted = false;
                        throw new Error(result.message);
                    }
                }, function (err) {
                    if (err.status === 500) {
                        $scope.result.code = '_REGISTRATION_ERROR_';
                        $scope.submitted = false;
                    }
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.close();
        };

        return $scope;
    };

    // introduce the user to the application once registration is complete
    signin.controller('IntroVideoModalCtrl', ['$scope', '$sce', function ($scope, $sce) {
        // show intro video
        var video_src = '//www.youtube.com/embed/COVZbH-gaOk?rel=0&amp;autoplay=1';
        $scope.video_src = $sce.trustAsResourceUrl(video_src);

        $scope.gotoProfile = function () {
            window.location = '/profile?new';
        };
    }]);

    //--------------------------------------------------------------[ Sign in Controller
    signin.controller('SigninCtrl', ['$scope', '$http', '$location', '$uibModal', function ($scope, $http, $location, $uibModal) {
        $scope.fromNav = true; // used to determine whether form is displayed in a modal or not
        $scope.open = function (e) {
            // Prevent the default action
            e.preventDefault();
            
            // let the modal controller know if we're using a modal or not
            var modalInstance = $uibModal.open({
                templateUrl: '/script/vspot-angular/templates/signin/login.html',
                controller: 'SigninModalCtrl',
                scope: $scope
            });

            // should we open another modal when this one closes?
            modalInstance.result.then(function (data) {
                if (data && data.action === 'forgotpassword') {
                    $scope.email = data.email;
                    // clicked on the forgot password link from the login modal
                    $uibModal.open({
                        templateUrl: '/script/vspot-angular/templates/signin/forgotpassword.html',
                        controller: 'ForgotPasswordModalCtrl',
                        scope: $scope
                    }).result.then(function (action) {
                        // show success message
                        if (action === 'success') {
                            $uibModal.open({
                                templateUrl: '/script/vspot-angular/templates/signin/resetpassword.html',
                                controller: 'ResetPasswordModalCtrl',
                                scope: $scope
                            });
                        }
                    });
                }
            });
        };
    }]);

    signin.controller('SigninModalCtrl', ['$scope', '$uibModalInstance', 'services.User', function ($scope, $uibModalInstance, User) {
        $scope = signinController($scope, $uibModalInstance, User);
    }]);

    signin.controller('SigninInlineCtrl', ['$scope', 'services.User', function ($scope, User) {
        $scope = signinController($scope, undefined, User);
    }]);

    signinController = function ($scope, $uibModalInstance, User) {
        $scope.form         = {};
        $scope.submitted    = false;
        $scope.errorEmail   = null;
        $scope.errorCode    = null;

        $scope.fbLogin = function () {
            var result;
            // where the user should go next;
            // nexturl is defined when the user is kicked out of somewhere else,
            // and we'd like to put them back where they were
            var nextUrl = global_helper.get_url_param('next_url') || '/Dashboard';

            result = User.fbLogin(function () {
                window.location = nextUrl;
            });

            if (!result) {
                $scope.errorCode = '_FACEBOOK_DOWN_';
            }
        };

        // go to forgot password screen/modal
        $scope.gotoForgotPassword = function () {
            // are we currently in a modal?
            if ($scope.fromNav) {
                // close modal; open login modal
                // send prefill data to forgot password
                $uibModalInstance.close({ action: 'forgotpassword', email: $scope.form.email });
            } else {
                // go to forgot password page
                window.location = '/login/forgotten';
            }
        };

        $scope.signin = function (event, form) {
            $scope.submitted    = true;
            $scope.errorEmail   = null;
            $scope.errorCode    = null;

            // login the user and show any returned errors
            User.login($scope.form.email, $scope.form.password).$promise.then(function (result) {
                if( result.status ) {
                    // where the user should go next;
                    // nexturl is defined when the user is kicked out of somewhere else,
                    // and we'd like to put them back where they were
                    var nextUrl = global_helper.get_url_param('next_url') || '/Dashboard';
                    window.location = nextUrl;
                } else {
                    $scope.submitted    = false;
                    $scope.errorEmail   = result.email;
                    $scope.errorCode    = result.code;
                }
            });
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        };
    };

    // prompt the user to reset their password
    signin.controller('ForgotPasswordModalCtrl', ['$scope', '$uibModalInstance', '$uibModal', 'services.User', function ($scope, $uibModalInstance, $uibModal, User) {
        $scope = forgotPwController($scope, $uibModalInstance, $uibModal, User);
    }]);

    signin.controller('ForgotPasswordInlineCtrl', ['$scope', '$uibModal', 'services.User', function ($scope, $uibModal, User) {
        $scope = forgotPwController($scope, undefined, $uibModal, User);
    }]);

    forgotPwController = function ($scope, $uibModalInstance, $uibModal, User) {
        var modalInstance;

        $scope.submitted = false;
        $scope.form = {};

        // prefill email from login form
        if ($scope.email) {
            $scope.form.email = $scope.email;
        }

        $scope.resetPassword = function () {
            $scope.submitted = true;

            User.resetPassword($scope.form.email).$promise.then(function (result) {
                if (result.status) {
                    if ($scope.fromNav) {
                        $uibModalInstance.close('success');
                    } else {
                        modalInstance = $uibModal.open({
                            templateUrl: '/script/vspot-angular/templates/signin/resetpassword.html',
                            controller: 'ResetPasswordModalCtrl',
                            scope: $scope
                        });

                        modalInstance.result.then(function () {
                            window.location = '/login/signin?triggerUri=' + encodeURIComponent(window.location.href) + '&fn=resetPassword';
                        });
                    }
                } else if (result.code) {
                    $scope.result = result;
                    $scope.submitted = false;
                } else {
                    $scope.submitted = false;
                    throw new Error(result.message);
                }
            }, function (err) {
                $scope.result = err;
                $scope.submitted = false;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.close();
        };
    };

    // controller to indicate success on resetting the user's password
    signin.controller('ResetPasswordModalCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.cancel = function () {
            $uibModalInstance.close();
        }
    }]);

});

